import { makeRequest, ApiResponseType } from "../../common/helpers/api.helpers";

const API_URL = import.meta.env.VITE_API_URL;

export interface MonitoringItemStatus {
  status: "ok" | "warning" | "error";
  lastEventAt: string | null;
}

export interface MonitoringStatusData {
  charges: {
    preparations: MonitoringItemStatus;
    maintenances: MonitoringItemStatus;
    trafficFines: MonitoringItemStatus;
  };
  webhooks: {
    charges: MonitoringItemStatus;
    payments: MonitoringItemStatus;
    trafficFines: MonitoringItemStatus;
  };
}

export async function getMonitoringStatus() {
  const url = `${API_URL}/monitoring/status`;
  const result = await makeRequest<MonitoringStatusData>(url);
  return result as ApiResponseType<MonitoringStatusData>;
}
